var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeyIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.043 22.7498H5.95964C3.86555 22.7498 2.16797 21.0523 2.16797 18.9582V18.9582C2.16797 16.8641 3.86555 15.1665 5.95964 15.1665H20.043C22.1371 15.1665 23.8346 16.8641 23.8346 18.9582V18.9582C23.8346 21.0523 22.1371 22.7498 20.043 22.7498Z",
    stroke: "#292929",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.763 18.9571C19.763 18.8108 19.6449 18.6928 19.4987 18.6938C19.3524 18.6938 19.2344 18.8119 19.2344 18.9582C19.2344 19.1044 19.3524 19.2225 19.4987 19.2225C19.6449 19.2225 19.763 19.1044 19.763 18.9571",
    stroke: "#292929",
    strokeWidth: 1.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.431 18.9571C15.431 18.8108 15.3129 18.6928 15.1667 18.6938C15.0204 18.6938 14.9023 18.8119 14.9023 18.9582C14.9023 19.1044 15.0204 19.2225 15.1667 19.2225C15.3118 19.2225 15.431 19.1044 15.431 18.9571",
    stroke: "#292929",
    strokeWidth: 1.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.099 18.9571C11.099 18.8108 10.9809 18.6928 10.8346 18.6938C10.6884 18.6938 10.5703 18.8119 10.5703 18.9582C10.5703 19.1044 10.6884 19.2225 10.8346 19.2225C10.9798 19.2225 11.099 19.1044 11.099 18.9571",
    stroke: "#292929",
    strokeWidth: 1.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.76303 18.9571C6.76303 18.8108 6.64495 18.6928 6.4987 18.6938C6.35245 18.6938 6.23436 18.8119 6.23436 18.9582C6.23436 19.1044 6.35245 19.2225 6.4987 19.2225C6.64386 19.2225 6.76303 19.1044 6.76303 18.9571",
    stroke: "#292929",
    strokeWidth: 1.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5846 9.28536V6.46436",
    stroke: "#292929",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2487 9.321V6.5",
    stroke: "#292929",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9629 4.20225C12.2326 5.47192 12.2326 7.52917 10.9629 8.79883C9.69323 10.0685 7.63598 10.0685 6.36631 8.79883C5.09665 7.52917 5.09665 5.47192 6.36631 4.20225C7.63598 2.93258 9.69431 2.93258 10.9629 4.20225",
    stroke: "#292929",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5846 6.46422L11.918 6.49997",
    stroke: "#292929",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyIc);
export default __webpack_public_path__ + "static/media/key_ic.ccf8df03e6d878058d48e8443c1e7e7c.svg";
export { ForwardRef as ReactComponent };